import React from 'react';

import { PlaceholderItem } from 'app/components/PlaceholderItem';
import { PageContentWrapper } from 'app/components/PageContentWrapper';
import { CalculationViewContentPlaceholderProps } from './CalculationViewContentPlaceholder.interfaces';
import { useStyles } from './CalculationViewContentPlaceholder.styles';
import { FormPlaceholder } from 'app/components/FormPlaceholder';

const CalculationViewContentPlaceholder = (
  props: CalculationViewContentPlaceholderProps
) => {
  const classes = useStyles();

  const { showLoadingAnimation } = props;

  return (
    <PageContentWrapper
      newAmbassadorStyle
      mainContent={
        <div className={classes.formPlaceholder}>
          <FormPlaceholder showLoadingAnimation={showLoadingAnimation} />
        </div>
      }
      sidebar={
        <PlaceholderItem
          classes={{ root: classes.sidebar }}
          rows={3}
          showLoadingAnimation={showLoadingAnimation}
        />
      }
      className={classes.pageContentWrapper}
    />
  );
};

export default CalculationViewContentPlaceholder;
